import { AbstractControl, UntypedFormGroup, Validators } from "@angular/forms";

import { NO_LIMIT } from "../responsible-gaming/deposit-limit/deposit-limit.const";

import { OBG_VALIDATORS } from "./validators";

export function sessionLimitAmountValidator(control: AbstractControl): {
	required?: boolean;
	numericNotZero?: boolean;
	numberSmallerOrEqual?: boolean;
} | null {
	if (control.parent) {
		const sessionLimitPeriod = (control.parent as UntypedFormGroup).controls.sessionLimitPeriod;
		if (
			sessionLimitPeriod &&
			!Validators.required(sessionLimitPeriod) &&
			sessionLimitPeriod.value !== NO_LIMIT.value
		) {
			return (
				Validators.required(control) ||
				OBG_VALIDATORS.numericNotZero(control) ||
				OBG_VALIDATORS.numberSmallerOrEqual(+sessionLimitPeriod.value * 24)(control)
			);
		}
	}

	return null;
}

export function zhhSessionLimitValidator(control: AbstractControl) {
	const ZHH_DAILY_SESSION_LIMIT_MIN_VALUE = 1;
	const ZHH_DAILY_SESSION_LIMIT_MAX_VALUE = 23;

	return (
		Validators.required(control) ||
		OBG_VALIDATORS.numericNotZero(control) ||
		OBG_VALIDATORS.numberSmallerOrEqual(ZHH_DAILY_SESSION_LIMIT_MAX_VALUE)(control) ||
		OBG_VALIDATORS.numberBiggerOrEqual(ZHH_DAILY_SESSION_LIMIT_MIN_VALUE)(control)
	);
}
